// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rowExpandedImg {
    cursor: pointer;
}

.fullView {
    max-height: 0;
    overflow: hidden;
    padding: 0 20px;
}

.fullView:first-letter {
    text-transform: capitalize;
}

.rowExpanded .fullView {
    max-height: 800px;
}

.rowExpanded .shortView {
    opacity: 0;
    max-height: 0;
}

.rowExpanded .rowExpandedImg {
    transform: scaleY(-1);
}

.rowExpanded td {
    vertical-align: top;
}

html {
    -webkit-print-color-adjust: exact;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;AACrC","sourcesContent":[".rowExpandedImg {\n    cursor: pointer;\n}\n\n.fullView {\n    max-height: 0;\n    overflow: hidden;\n    padding: 0 20px;\n}\n\n.fullView:first-letter {\n    text-transform: capitalize;\n}\n\n.rowExpanded .fullView {\n    max-height: 800px;\n}\n\n.rowExpanded .shortView {\n    opacity: 0;\n    max-height: 0;\n}\n\n.rowExpanded .rowExpandedImg {\n    transform: scaleY(-1);\n}\n\n.rowExpanded td {\n    vertical-align: top;\n}\n\nhtml {\n    -webkit-print-color-adjust: exact;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
